export const AccountType = {
  0: 'Client',
  1: 'Vendor'
};

export const accountTypesList = [
  { name: 'Checking', id: 'Checking' },
  { name: 'Saving', id: 'Saving' }
];
export const defaultFinStudyTypeOptions = [
  { name: 'Elligo Managed', id: 'ELLIGO_MANAGED' },
  { name: 'FMS', id: 'FMS' },
  { name: 'Patient Travel', id: 'PATIENT_TRAVEL' }
];
export const elligoDirectDomain = '@elligodirect.com';
export const US = 'US';
export const CA = 'CA';
export const UK = 'UK';
